import { IResponse } from "../../services/interface/data";

/**
 * getDataStatus
 * @description Provides a status string based on the data provided
 * @param data
 * @returns {string}
 */
export const getDataStatus = (data: IResponse | undefined): string => {
    // When should
    let status = "none";
    const { thread_id, page_content, follow_up_prompts } = data || {};

    if (thread_id) {
        status = "working";
    }
    // loop through page_content, if the first two are complete, we can allow scrolling
    if (page_content) {
        // loop through page_content, count the number of items that have fields in the component_properties object
        const completeCount = page_content.filter(
            (entry) => Object.keys(entry.component_properties).length > 0
        ).length;

        if (completeCount >= 2) {
            status = "ready";
        }
        if (completeCount === page_content.length) {
            status = "complete";
        }
    }
    return status;
};
